import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, watch } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import CurrencyInput from "@/components//ui/inputs/currency-input.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'set-payment-run-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The initial value for the float amount that is displayed in the input field.
   * @type {number}
   * @required
   */
  initialValue: {
    type: Number,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Triggered when a new float amount is entered and the save action is performed.
   * The new value is displayed in the payment run modal grid
   * @property {number} newFloatAmount - The new float amount that has been entered by the user.
   */
  "newFloatEntered",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

watch(
  () => showModal.value,
  () => {
    floatAmount.value = props.initialValue;
  },
);

const floatAmount = ref(0);

const onSaveClick = () => {
  emit("newFloatEntered", floatAmount.value);
  showModal.value = false;
};

const onCancelClick = () => (showModal.value = false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event)),
    title: "Payment Run"
  }, {
    content: _withCtx(() => [
      _createVNode(CurrencyInput, {
        label: "Set Float Amount",
        modelValue: floatAmount.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((floatAmount).value = $event))
      }, null, 8, ["modelValue"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Save',
          onClick: () => {
            onSaveClick();
          },
        }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})